export const messages = {
  en: {
    roomBindOwner: {
      title: 'House Handover',
      room: 'Room',
      owner: 'Owner',
      startTime: 'Start Time',
      endTime: 'End Time',
      roomPlaceholder: 'Required, please enter room name',
      ownerPlaceholder: 'Required, please select owner',
      startTimePlaceholder: 'Required, please enter start time',
      endTimePlaceholder: 'Required, please enter end time',
      selectOwner: 'Select Owner',
      roomRequired: 'Room cannot be empty',
      ownerRequired: 'Owner cannot be empty',
      startTimeRequired: 'Start time cannot be empty',
      endTimeRequired: 'End time cannot be empty',
      timeError: 'End time must be greater than start time',
      fetchRoomError: 'Failed to get room information'
    },
    searchOwner: {
      ownerId: 'Owner ID',
      title: 'Select Owner',
      roomPlaceholder: 'Enter room number (building-unit-room)',
      ownerPlaceholder: 'Enter owner name',
      memberId: 'Owner ID',
      name: 'Name',
      personType: 'Person Type',
      personRole: 'Person Role',
      idCard: 'ID Card',
      contact: 'Contact'
    }
  },
  zh: {
    roomBindOwner: {
      title: '房屋交房',
      room: '房屋',
      owner: '业主',
      startTime: '开始时间',
      endTime: '结束时间',
      roomPlaceholder: '必填，请填写房屋名称',
      ownerPlaceholder: '必填，请选择业主',
      startTimePlaceholder: '必填，请填写开始时间',
      endTimePlaceholder: '必填，请填写结束时间',
      selectOwner: '选择业主',
      roomRequired: '房屋不能为空',
      ownerRequired: '业主不能为空',
      startTimeRequired: '开始时间不能为空',
      endTimeRequired: '结束时间不能为空',
      timeError: '结束时间必须大于开始时间',
      fetchRoomError: '获取房屋信息失败'
    },
    searchOwner: {
      ownerId: '业主编号',
      title: '选择业主',
      roomPlaceholder: '输入房屋编号(楼栋-单元-房屋)',
      ownerPlaceholder: '输入业主名称',
      memberId: '业主编号',
      name: '名称',
      personType: '人员类型',
      personRole: '人员角色',
      idCard: '证件号',
contact: '联系方式'
    }
  },
  'zh-TW': {
    roomBindOwner: {
      title: '房屋交房',
      room: '房屋',
      owner: '業主',
      startTime: '開始時間',
      endTime: '結束時間',
      roomPlaceholder: '必填，請填寫房屋名稱',
      ownerPlaceholder: '必填，請選擇業主',
      startTimePlaceholder: '必填，請填寫開始時間',
      endTimePlaceholder: '必填，請填寫結束時間',
      selectOwner: '選擇業主',
      roomRequired: '房屋不能為空',
      ownerRequired: '業主不能為空',
      startTimeRequired: '開始時間不能為空',
      endTimeRequired: '結束時間不能為空',
      timeError: '結束時間必須大於開始時間',
      fetchRoomError: '獲取房屋信息失敗'
    },
    searchOwner: {
      ownerId: '業主編號',
      title: '選擇業主',
      roomPlaceholder: '輸入房屋編號(樓棟-單元-房屋)',
      ownerPlaceholder: '輸入業主名稱',
      memberId: '業主編號',
      name: '名稱',
      personType: '人員類型',
      personRole: '人員角色',
      idCard: '證件號',
      contact: '聯繫方式'
    }
  }
}